module.exports = __webpack_public_path__ + "img/icon_ftp-1.0dfe5304.png";